<template>
  <div>
    <div class="comond_btn">
      <el-button  @click="handleEdit(0, null)" >添加商品分类</el-button>
    </div>
    <template>
      <el-row>
        <el-col :span="8">
          <el-table
            :data="parentlist"
            @current-change="handleCurrentChange"
            @row-click="handleRowDblclick"
            style="width: 100%">
            <el-table-column
              prop="name"
              label="一级分类"
              width="">
            </el-table-column>
            <el-table-column
              label="操作选项">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  @click="handleEdit(1, scope.row)">编辑</el-button>
                <el-button
                  size="mini"
                  type="danger"
                  @click="handleDelete(1, scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
        <el-col :span="1">&nbsp;</el-col>
        <el-col :span="15">
          <el-table
            :data="childlist"
            style="width: 100%">
            <el-table-column
              prop="name"
              label="二级分类"
              width="">
            </el-table-column>
            <el-table-column
              label="操作选项">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  @click="handleEdit(2, scope.row)">编辑</el-button>
                <el-button
                  size="mini"
                  type="danger"
                  @click="handleDelete(2, scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </template>
    <div>
      <el-dialog :title="title" :visible.sync="centerDialogVisible">
         <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="一级分类" name="first">
                 <el-form>
                    <el-form-item label="一级分类" :labelWidth="formLabelWidth">
                        <el-input v-model="form.type" clearable></el-input>
                    </el-form-item>
                </el-form>
            </el-tab-pane>
            <el-tab-pane label="二级分类" name="second">
                <el-form>
                    <el-form-item label="一级分类" :label-width="formLabelWidth">
                        <el-select v-model="form.parentId" filterable placeholder="请选择">
                            <el-option
                              v-for="item in parentlist"
                              :key="item.key"
                              :label="item.name"
                              :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="二级分类" :labelWidth="formLabelWidth">
                        <el-input v-model="form.type" clearable></el-input>
                    </el-form-item>
                </el-form>
            </el-tab-pane>
        </el-tabs>
        <div class="dialog-footer">
            <el-button @click="centerDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="handleSave(activeName)">确 定</el-button>
        </div>
    </el-dialog>
    </div>
  </div>
</template>
<script>
import { goodsTypefindAll, goodsTypeadd, goodsTypeupdateById, goodsTypedelete, goodsTypegetByParentId } from '../../api'
import utils from '../../../public/utils'
import qs from 'qs'
export default {
  data () {
    return {
      parentlist: [], //  父级分类
      childlist: [], //  子级分类
      centerDialogVisible: false,
      form: { //  新增初始化form
        parentId: '',
        type: ''
      },
      activeName: 'first',
      formLabelWidth: '80px',
      sts: 0, //  0 添加, 1 编辑
      title: '', //  添加窗口标题
      currentid: ''
    }
  },
  methods: {
    handleCurrentChange (row) {
      console.log(row)
    },
    handleRowDblclick (row, event) { //  双击某一行
      this.form.parentId = row.id
      this.getgoodsTypegetByParentId(1, row.id)
    },
    handleSave (s) { //  添加分类
      let para = new URLSearchParams()
      if (s === 'first') {
        para.append('type', this.form.type)
      } else {
        para.append('parentId', this.form.parentId)
        para.append('type', this.form.type)
      }
      if (this.sts === 0) {
        goodsTypeadd(para).then(data => {
          if (data.code === 10000) {
            this.$message({
              message: data.msg,
              type: 'success'
            })
            this.getgoodsTypegetByParentId(1, this.form.parentId)
            this.centerDialogVisible = false
          } else {
            this.$message({
              message: data.msg,
              type: 'error'
            })
          }
        })
      } else {
        para.append('id', this.currentid)
        goodsTypeupdateById(para).then(data => {
          if (data.code === 10000) {
            this.$message({
              message: data.msg,
              type: 'success'
            })
            this.getgoodsTypegetByParentId(1)
            this.getgoodsTypegetByParentId(1, this.form.parentId)
            this.centerDialogVisible = false
          } else {
            this.$message({
              message: data.msg,
              type: 'error'
            })
          }
        })
      }
      
    },
    handleClick () {
      this.form = {}
    },
    handleEdit (ind, row) { //  编辑或者新增
      this.centerDialogVisible = true
      console.log(ind, row)
      if (ind === 1) {
        this.currentid = row.id
        this.title = '编辑商品分类'
        this.form.type = row.name
        this.sts = 1
        this.activeName = 'first'
      } else if (ind === 0) {
        this.title = '新增商品分类'
        this.form = {}
        this.sts = 0
      } else {
        this.currentid = row.id
        this.activeName = 'second'
        this.form.parentId = row.parent
        console.log(this.form.parentId)
        this.form.type = row.name
        this.sts = 2
      }
    },
    handleDelete (ind, row) { //  删除
      console.log(ind, row)
      let para = new URLSearchParams()
      para.append('id', row.id)
      goodsTypedelete(para).then(data => {
        if (data.code === 10000) {
            this.$message({
              message: data.msg,
              type: 'success'
            })
            this.getgoodsTypegetByParentId(1)
            this.getgoodsTypegetByParentId(1, this.form.parentId)
          } else {
            this.$message({
              message: data.msg,
              type: 'error'
            })
          }
      })
    },
    getgoodsTypegetByParentId (s, p) { //  查询全部
      if (p) {
        let params = {
          status: s,
          parentId: p
        }
        goodsTypegetByParentId(params).then(data => {
          console.log(data)
          this.childlist = data.data.data
        })
      } else {
        let params = {
          status: s,
        }
        goodsTypegetByParentId(params).then(data => {
          console.log(data)
          this.parentlist = data.data.data
        })
      }
    },
    formatime (s) { //  格式化时间
      let a = utils.formatterTime(s)
      return a
    },
  },
  mounted () {
    this.getgoodsTypegetByParentId(1)
  }
}
</script>
<style lang="stylus" scoped>
.comond_btn
  display flex
  justify-content flex-end
  margin-bottom 30px
  button
    background-color #0a3d5f
    color #fff
</style>
